<zelis-expansion-panel
  [multi]="true"
  [panelData]="panelData"
  [buttonColor]="'accent'"
  [buttonVariant]="'stroked'"
  [expanded]="expand"
  (analytics)="logAnalytics($event)"
  id="pendo-virtual-care"
>
  <ng-template let-vendor>
    <span [innerHTML]="vendor.content"></span>

    <mat-divider
      *ngIf="vendor.telehealth?.phone || vendor.telehealth?.waitTime"
      class="my-4"
    ></mat-divider>

    <div
      class="text-base telehealth-sub-content"
      data-cy="telehealth-sub-content"
    >
      <div
        *ngIf="vendor.telehealth?.phone"
        data-cy="extension-panel-phone-number"
      >
        <div class="text-sm text-palette-m3-system-gray-35">
          {{ 'app_global_phone' | translate }}
        </div>
        <a
          [innerHTML]="vendor.telehealth.phone"
          href="tel:{{ vendor.telehealth.phone }}"
          appGtm
          [gtmOnClick]="true"
          [gtmData]="{
            event: 'telehealth_vendor_phone',
            vendor_name: vendor.title
          }"
        >
        </a>
      </div>

      <div
        *ngIf="vendor.telehealth?.waitTime"
        class="md:ml-20"
        data-cy="extension-panel-average-wait-time"
      >
        <div class="text-sm text-palette-m3-system-gray-35">
          {{ 'telehealth_average_wait_time' | translate }}
        </div>
        <span [innerHTML]="vendor.telehealth.waitTime"></span>
      </div>
    </div>
  </ng-template>
</zelis-expansion-panel>
